import { Projeto } from '../tipos/projeto'
import { FormularioProjeto } from './FormularioProjeto'
import { useProjeto } from '../hooks/useProjeto'
import { Modal } from '../../../componentesCompartilhados/ui/Modal'
import { FolderOpen } from 'lucide-react'

interface ProjetoDetalhesDrawerProps {
  projeto: Projeto
  isOpen: boolean
  onClose: () => void
}

export function ProjetoDetalhesDrawer({
  projeto,
  isOpen,
  onClose,
}: ProjetoDetalhesDrawerProps) {
  const { data: projetoCompleto, isLoading } = useProjeto(String(projeto.id))

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={isLoading ? 'Carregando...' : projetoCompleto?.nome || projeto.nome}
      subtitle="Editar projeto"
      size="4xl"
      icon={
        <div className="w-10 h-10 bg-brand-100 text-brand-600 rounded-lg flex items-center justify-center flex-shrink-0 min-w-[2.5rem] min-h-[2.5rem]">
          <FolderOpen className="w-5 h-5" />
        </div>
      }
    >
      {isLoading ? (
        <div className="flex items-center justify-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-500"></div>
        </div>
      ) : projetoCompleto ? (
        <FormularioProjeto
          isOpen={true}
          onClose={onClose}
          projeto={projetoCompleto}
          isEditing={true}
          isLoadingProjeto={isLoading}
          renderInline={true}
        />
      ) : (
        <div className="text-center py-12 text-gray-500">
          Erro ao carregar projeto
        </div>
      )}
    </Modal>
  )
}

